import React, { forwardRef, useMemo } from 'react';

const toFields = (obj, keyCallback = key => `questionnaire[${key}][]`, valCallback = v => v) =>
  Object.keys(obj).reduce(
    (acct, key) => [
      ...acct,
      ...obj[key].map(v => ({ name: keyCallback(key), value: valCallback(v) })),
    ],
    [],
  );

const GettingStartedForm = ({ action, token, values, children }, ref) => {
  const fields = useMemo(
    () => {
      const { family, rooms, address, ...rest } = values;
      const pets = Object.values(family.pets).map((p, index) => ({
        name: `questionnaire[peoples][pets][${index}][${p.type}]`,
        value: p.name || p.type,
      }));
      const adults = Object.values(family.adults).reduce(
        (acct, a, index) => [
          ...acct,
          { name: `questionnaire[peoples][adults][${index}][${a.gender}]`, value: a.age },
        ],
        [],
      );
      const kids = Object.values(family.children).reduce(
        (acct, c, index) => [
          ...acct,
          { name: `questionnaire[peoples][children][${index}][${c.gender}]`, value: c.age },
        ],
        [],
      );
      const roomsFields = rooms.reduce(
        (acct, room) => [
          ...acct,
          { name: `questionnaire[rooms][${room.type}]`, value: room.quantity },
        ],
        [],
      );
      const addressFields = Object.keys(address).reduce(
        (acct, i) =>
          address[i] ? [...acct, { name: `questionnaire[${i}]`, value: address[i] }] : acct,
        [],
      );
      return [...pets, ...adults, ...kids, ...roomsFields, ...addressFields].concat(toFields(rest));
    },
    [values],
  );

  return (
    <form ref={ref} action={action} method="POST">
      <input type="hidden" name="authenticity_token" value={token} />
      {fields.map((field, index) => (
        <input
          key={`${field.name}${field.value}${index}`}
          type="hidden"
          name={field.name}
          value={field.value}
        />
      ))}
      {children}
    </form>
  );
};

export default forwardRef(GettingStartedForm);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedForm.js